import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import Image from 'next/image'
import BorderBtn from '../components/Common/BorderBtn'

const Navbar = dynamic(() => import('../components/Layouts/Navbar', { ssr: false }));
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }));
const Breadcrumb = dynamic(() => import('../components/Layouts/Breadcrumb', { ssr: false }));
import algoliasearch from 'algoliasearch/lite';
import {
    InstantSearch,
    Pagination,
    SearchBox,
    Highlight,
    Configure,
    useConnector,
    useHits,
    HitsPerPage
} from 'react-instantsearch';
import axios from 'axios'
import {
    faMagnifyingGlass,
    faEarthEurope,
    faStop,
    faMicrophone
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    limitText,
} from '../components/Common/Functions'
import connectVoiceSearch from 'instantsearch.js/es/connectors/voice-search/connectVoiceSearch';

const useVoiceSearch = (props) => {
    return useConnector(connectVoiceSearch, props);
};

const VoiceSearch = (props) => {
    const {
        isListening,
        toggleListening,
    } = useVoiceSearch(props);

    return (
        <>
            <button onClick={toggleListening}>
                <div className='flex'>
                    <FontAwesomeIcon icon={isListening ? faStop : faMicrophone} className='text-[#1e5df3]' />
                </div>

            </button>
        </>
    );
};

const CaseStudies = () => {

    const mainKey = 'UKQLSUI7R1'
    const securityKey = 'ed79e9bfe318ce8368e033ccc51cf3c7'


    const searchClient = algoliasearch(mainKey, securityKey);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1000);
    }, [])

    const GoToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    function CustomHits(props) {
        const { hits, results, banner, sendEvent } = useHits(props);

        return (
            <div>
                {hits.length === 0 ? (
                    <div className="py-8 text-center">
                        <h3 className="text-xl font-semibold">No results found</h3>
                        <p>Try adjusting your search or filter to find what you&apos;re looking for.</p>
                        <Link href="/contact-us"><button className='bg-[#1b5df3] md:text-xs lg:text-sm xl:text-base text-white py-1 px-4 rounded hightLightBtn'>Contact us</button>
                        </Link>
                    </div>
                ) : (
                    <ol>
                        <div className='grid grid-cols-12 gap-4'>
                            {hits.map((hit, index) => (
                                <div key={index} className='col-span-12 lg:col-span-4 md:col-span-6'>
                                    <div className="w-full h-full overflow-hidden rounded shadow-md">
                                        <div className="">
                                            <Link href={process.env.APP_URL + '/case-study/' + hit.slug}>
                                                {(hit.image === "") ? (
                                                    <Image priority={false}
                                                        loading="lazy"
                                                        className="w-full h-auto"
                                                        alt="report image delveinsight"
                                                        src={process.env.IMG_CDN + 'img/report-store/jpg/488592_Acromegaly_-_Pipeline_Insights,2018.jpg'}
                                                        width={2000}
                                                        height={2000}
                                                    />
                                                ) : (
                                                    <Image priority={false}
                                                        loading="lazy"
                                                        className="w-full h-auto"
                                                        src={process.env.IMG_CDN + hit.image}
                                                        alt="report image delveinsight"
                                                        width={2000}
                                                        height={2000}
                                                    />
                                                )}
                                            </Link>
                                        </div>
                                        <div className="object-cover group transition-all duration-500 mb-0 cursor-pointer w-full lg:h-48 h-52 relative p-4 bg-white delay-150 transform translate-y-0 hover:translate-y-[-100px]">
                                            <div className='group-hover:hidden'>
                                                <Link href={process.env.APP_URL + '/case-study/' + hit.slug}>
                                                    <h3 className="text-lg font-semibold line-clamp-1 text-[#1b5df3]">
                                                        <Highlight attribute="title" hit={hit} />
                                                    </h3>
                                                </Link>
                                                <p className='my-2'>{hit.coverage?.length > 0 ? <><FontAwesomeIcon icon={faEarthEurope} size="sm" className='text-[#1d5ef3]' /> {hit.coverage[0].value}</> : ''}</p>
                                                <div className="text-gray-700 lg:text-[15px] text-base dark:text-white caseUlDesign" dangerouslySetInnerHTML={{ __html: hit.highlights }} />
                                            </div>
                                            <div className='hidden transition-all duration-500 group-hover:block hover:-webkit-box hover:-webkit-line-clamp-6 hover:-webkit-box-orient-vertical hover:overflow-hidden group-hover:bottom-0 group-hover:transition-all group-hover:duration-500 group-hover:delay-300'>
                                                <Link href={process.env.APP_URL + '/case-study/' + hit.slug}>
                                                    <h3 className="text-lg font-semibold line-clamp-1 text-[#1b5df3]">
                                                        <Highlight attribute="title" hit={hit} />
                                                    </h3>
                                                </Link>
                                                <p className='my-2'>{hit.coverage?.length > 0 ? <><FontAwesomeIcon icon={faEarthEurope} size="sm" className='text-[#1d5ef3]' /> {hit.coverage[0].value}</> : ''}</p>
                                                <p className="line-clamp-5">
                                                    {limitText(hit.short_description)}
                                                </p>
                                                <BorderBtn
                                                    buttonTitle="View Study"
                                                    customClass="flex justify-center mx-auto my-4 bg-[#1b5df3] text-sm font-semibold text-white px-3 py-2 rounded-md"
                                                    buttonLink={process.env.APP_URL + '/case-study/' + hit.slug}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </ol>
                )}
            </div>
        );
    }


    return (
        <>
            <Navbar />
            <div className='mt-65'>
                <Breadcrumb />
            </div>
            <div className="flex flex-col justify-center w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8">
                <div>
                    <div className='grid grid-cols-12'>
                        <div className='col-span-12 lg:col-span-12'>
                            <InstantSearch searchClient={searchClient} stalledSearchDelay={1000} indexName="case_studies" future={{
                                preserveSharedStateOnUnmount: true,
                                persistHierarchicalRootCount: true,
                            }} >
                                <Configure hitsPerPage={9} />
                                <div className="col-span-12 lg:col-span-9">
                                    <div className='flex flex-col justify-between mb-4 md:flex-row'>
                                        <h1 className="text-xl font-semibold">Pharma Case Studies</h1>
                                        <div className="flex items-center mt-2 text-sm font-semibold">
                                            <span className="mr-2 ">Posts Per Page:</span>
                                            <HitsPerPage
                                                items={[
                                                    { label: '9', value: 9, default: true },
                                                    { label: '18', value: 18 },
                                                ]}
                                                className='px-2 border'
                                            />
                                        </div>
                                    </div>

                                    <div className="relative">

                                        <SearchBox autoFocus={true} placeholder="Search for case studies" />

                                        <div>
                                            <span className="search-icon-alg"><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
                                            <div className="voiceTextSiteSearch text-[14px]"><VoiceSearch /></div>
                                        </div>

                                        {
                                            isLoading === true ? <><div className="flex items-center justify-center min-h-screen">
                                                <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                            </div>
                                            </> : <div className="mt-6">
                                                <CustomHits />
                                            </div>
                                        }
                                        <Pagination showLast onClick={GoToTop} />
                                    </div>
                                </div>
                            </InstantSearch>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}


CaseStudies.getInitialProps = async (NextPageContext) => {
    const slugData = NextPageContext.pathname
    try {
        const response = await axios.get(process.env.API_URL + '/meta' + slugData);
        return {
            title: (response?.data.meta_title) ? response?.data.meta_title : "Case Study | DelveInsight",
            description: (response?.data.meta_description) ? response?.data.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: (response?.data.meta_keywords) ? response?.data.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        }
    } catch (error) {
        console.error('Error fetching data:', error.message);
        return {
            title: "Case Study | DelveInsight",
            description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends.",
        };
    }
}

export default CaseStudies;